/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_ReturnsInputs */

const en_seo_endpoint_q_returns = /** @type {(inputs: Seo_Endpoint_Q_ReturnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What does the ${i?.name} ${i?.action} API return?`)
};

const zh_hans1_seo_endpoint_q_returns = /** @type {(inputs: Seo_Endpoint_Q_ReturnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API 返回什么？`)
};

const pt_br2_seo_endpoint_q_returns = /** @type {(inputs: Seo_Endpoint_Q_ReturnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O que o endpoint ${i?.action} da API para ${i?.name} retorna?`)
};

const es_seo_endpoint_q_returns = /** @type {(inputs: Seo_Endpoint_Q_ReturnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Qué devuelve el endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_returns = /** @type {(inputs: Seo_Endpoint_Q_ReturnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Que renvoie l’API ${i?.name} ${i?.action} ?`)
};

const de_seo_endpoint_q_returns = /** @type {(inputs: Seo_Endpoint_Q_ReturnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Was liefert die ${i?.name}-${i?.action}-API zurück?`)
};

const ru_seo_endpoint_q_returns = /** @type {(inputs: Seo_Endpoint_Q_ReturnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Что возвращает API ${i?.name} ${i?.action}?`)
};

const it_seo_endpoint_q_returns = /** @type {(inputs: Seo_Endpoint_Q_ReturnsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cosa restituisce l'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "What does the {name} {action} API return?" |
*
* @param {Seo_Endpoint_Q_ReturnsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_returns = /** @type {((inputs: Seo_Endpoint_Q_ReturnsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_ReturnsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_returns(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_returns(inputs)
	if (locale === "es") return es_seo_endpoint_q_returns(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_returns(inputs)
	if (locale === "de") return de_seo_endpoint_q_returns(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_returns(inputs)
	if (locale === "it") return it_seo_endpoint_q_returns(inputs)
	return en_seo_endpoint_q_returns(inputs)
});